/**
 * Pull-out bases (claude-docs/2026-10-30-venus-full-line-design.md, group 4):
 * base bay fronts sold at one width — the one rule the panel and the fill
 * read for where they are offered.
 *
 *   - `trash` — Venus `B18TR`, "Trash Pull Out (incl. 2 Basket) w/ 1 Drawer",
 *     18" wide: a drawer over the bins' pull-out front;
 *   - `spice` — Venus `BF09-PO`, "Spice Rack w/ 3 Shelf", 9" wide: one
 *     full-height pull-out.
 *
 * A generic line offers them at the same widths. `applyBayType` builds them
 * (a `drawers` column; the fill draws a Venus one as its part's drawers) and
 * `resolveSku` bills them as the line's part.
 *
 * Pure.
 */
const IN = 0.0254;
const TOL_IN = 1 / 16;

/** Each pull-out front's width and its name in a reason. */
const PULL_OUTS = Object.freeze({
  trash: Object.freeze({ widthIn: 18, name: 'trash pull-out' }),
  spice: Object.freeze({ widthIn: 9, name: 'spice pull-out' }),
});

const said = (m) => `${Math.round((m / IN) * 8) / 8}"`;

/**
 * Why this bay cannot wear the pull-out `frontId`, or null when it can (or
 * the front is no pull-out): it is sold at one width.
 */
function pullOutReason(run, cabinet, frontId) {
  const spec = PULL_OUTS[frontId];
  const widthM = cabinet?.dimensions?.x;
  if (!spec || !(widthM > 0)) return null;
  if (Math.abs(widthM / IN - spec.widthIn) <= TOL_IN) return null;
  const article = /^[aeiou]/.test(spec.name) ? 'An' : 'A';
  return `${article} ${spec.name} is ${spec.widthIn}" wide: this bay is ${said(widthM)}`;
}

module.exports = { PULL_OUTS, pullOutReason };
